import { useState, useEffect } from 'react';
import useGalleryBehaviors from '../../hooks/useGalleryBehvaiors';
import useAuthenticatedApi from '../../../../Authentication/components/hooks/useAuthenticatedApi';

export default function useFavorites() {
    const authenticatedApi = useAuthenticatedApi();

    const [isLoading, setIsLoading] = useState(true);
    const [photos, setPhotos] = useState<MediaInstance[]>([]);
    const [delayed, setDelayed] = useState(false);
    const [gallery, setGallery] = useState<GalleryObject | null>(null);
    const [loadedPhotos, setLoadedPhotos] = useState<MediaInstance[]>([]);
    const [expandedIndex, setExpandedIndex] = useState(-1);

    const getFavorites = async () => {
        const response = await authenticatedApi.get('/activations/favorites');

        const { data } = response;
        return data;
    };

    const getNewPage = (count: number) => {
        if (
            photos.length === loadedPhotos.length &&
            loadedPhotos.length !== 0
        ) {
            return;
        }

        setLoadedPhotos([
            ...loadedPhotos,
            ...photos.slice(
                loadedPhotos.length - 1,
                loadedPhotos.length + count - 1,
            ),
        ]);
    };

    const advance = () => {
        if (expandedIndex === loadedPhotos.length - 1) {
            getNewPage(10);
        }
        if (expandedIndex < photos.length) {
            setExpandedIndex(expandedIndex + 1);
        } else {
            setExpandedIndex(-1);
        }
    };

    const reverse = () => {
        setExpandedIndex(expandedIndex >= 0 ? expandedIndex - 1 : -1);
    };

    const { swipeHandlers } = useGalleryBehaviors(
        setExpandedIndex,
        advance,
        reverse,
    );

    useEffect(() => {
        if (!isLoading) {
            setTimeout(() => setDelayed(true), 100);
        }
    }, [isLoading]);

    useEffect(() => {
        if (loadedPhotos.length === 0) {
            setLoadedPhotos([
                ...photos.slice(0, window?.outerWidth > 1500 ? 20 : 10),
            ]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [photos.length]);

    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            try {
                const gallery: GalleryObject = {
                    name: 'The Best',
                    activationId: 0,
                    id: 0,
                    foregroundColor: '#000000',
                    backgroundColor: '#ffffff',
                    headerBackgroundColor: '#000000',
                    headerForegroundColor: '#ffffff',
                    backgroundImage: null,
                    showGalleryLink: false,
                    isPrivate: false,
                    password: '',
                    emailEnabled: false,
                    textEnabled: false,
                    ageVerification: false,
                    verifiedAge: null,
                    surveyRequired: false,
                    ctaImage: null,
                    ctaLink: null,
                    ctaText: null,
                    font: null,
                    logo: null,
                    surveyQuestions: null,
                    metaPixelId: null,
                    sharingStationArea1ImageUri: null,
                    sharingStationArea2ImageUri: null,
                    displayGalleryUserSignup: false,
                    disclaimer: null,
                    disclaimerEnabled: false,
                    disclaimerOptOut: false,
                    disclaimerRequired: false,
                    createShareDescriptionText: null,
                    createShareDescriptionTextSize: null,
                    createShareDescriptionTextFont: null,
                    surveyUrl: null,
                    baseUrl: null,
                    slug: null,
                };

                const photos = await getFavorites();

                setGallery(gallery);
                setPhotos(photos);
            } catch (e) {
                console.error(e);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        load();
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        photos,
        isLoading,
        gallery,
        swipeHandlers,
        expandedIndex,
        setExpandedIndex,
        delayed,
        loadedPhotos,
        getNewPage,
    };
}
